import { render } from "./Calls.vue?vue&type=template&id=7c60dd06&scoped=true&ts=true"
import script from "./Calls.vue?vue&type=script&lang=ts"
export * from "./Calls.vue?vue&type=script&lang=ts"

import "./Calls.vue?vue&type=style&index=0&id=7c60dd06&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c60dd06"]])

export default __exports__